import { IBoxStorageFile } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllDocuments = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage`);
    return data as IBoxStorageFile[];
};

export const getAllDocumentCategory = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/category`
    );

    return data as string[];
};

export const getSignedUrl = async (payload: { filename: string; storage: string; extension: string }) => {
    const { data } = await http.post(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/get-url`,
        payload
    );
    return data;
};
export const storeFileToServer = async (payload: {
    filename: string;
    key: string;
    category: string;
    storage: string;
}) => {
    const { data } = await http.post(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/complete`,
        payload
    );
    return data;
};

export const removeDocument = async (documentId: string) => {
    const { data } = await http.delete(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/${documentId}`
    );
};

export const getAvailableStorageList = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/storage-names`
    );
    return data;
};

export type TMultipartInitPayload = {
    filename: string;
    storage: string;
    contentType: string;
    extension?: string;
};

export type TMultipartInitResponse = {
    uploadId: string;
    key: string;
};

export type TMultipartPartUrlPayload = {
    storage: string;
    key: string;
    uploadId: string;
    PartNumber: number; // backend expects PartNumber (capital P,N)
    contentType?: string;
};

export type TMultipartPartUrlResponse = {
    url: string;
};

export type TMultipartCompletePayload = {
    storage: string;
    key: string;
    uploadId: string;
    parts: { PartNumber: number; ETag: string }[];
    contentType?: string;
    category?: string;
};

export type TMultipartCompleteResponse = any;

export const initMultipartUpload = async (payload: TMultipartInitPayload) => {
    const { data } = await http.post<TMultipartInitResponse>(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/multipart/init`,
        payload
    );
    return data;
};

export const getMultipartUploadPartUrl = async (payload: TMultipartPartUrlPayload) => {
    const { data } = await http.post<TMultipartPartUrlResponse>(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/multipart/part-url`,
        payload
    );
    return data;
};

export const completeMultipartUpload = async (payload: TMultipartCompletePayload) => {
    const { data } = await http.post<TMultipartCompleteResponse>(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/box-storage/multipart/complete`,
        payload
    );
    return data;
};
